export default "__VITE_ASSET__DHOgM1He__"